import { Button, Modal } from "antd";
import styled from "styled-components";

export const BonusCredentialModalContainer = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
    padding: 24px;
  }

  .ant-modal-body {
    padding: 0;
  }

  .ant-modal-header {
    border-bottom: none;
  }

  .ant-modal-footer {
    padding: 0;
    margin-top: 24px;
    border-top: none;
  }

  @media (max-width: 600px), (max-height: 500px) {
    width: 90% !important;
    max-width: 90% !important;

    .ant-modal-content {
      max-height: 90vh;
      display: flex;
      flex-direction: column;
    }

    .ant-modal-body {
      overflow-y: auto;
      max-height: 60vh;
    }
  }
`;

export const HeaderModal = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    background: #f9f9fd;
  }
`;

export const ModalTitle = styled.div`
  font-family: "Open Sans";
  font-weight: 700;
  font-size: 20px;
  line-height: 100%;
  color: #314158;
`;

export const ModalSubTitle = styled.span`
  font-family: "Inter";
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: rgba(98, 116, 142, 1);
`;

export const FormRow = styled.div`
  display: flex;
  gap: 16px;

  > * {
    flex: 1;
    min-width: 0;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 0;
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-top: 24px;
`;

export const ButtonFormConfirm = styled(Button)`
  font-family: "Inter", sans-serif;
  border-radius: 10px;
  border: none;
  height: 38px;
  width: 109px;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0px 1px 2px 0px rgba(25, 25, 28, 0.04);
  margin-top: 0;

  &:disabled {
    background-color: #d3d3d3 !important;
    color: #a1a1a1 !important;
    border: none !important;
    cursor: not-allowed;
  }
`;
